import { useCurrentStateAndParams } from "@uirouter/react";

import { PageContainer } from "app/pages/industry-analysis/common/styledComponents";
import { PreDefinedIndustriesBenchmarkBanner } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/banner/PreDefinedIndustriesBenchmarkBanner";
import { PreDefinedIndustriesBenchmarkTable } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/PreDefinedIndustriesBenchmarkTable";
import { GrowthOverview } from "app/pages/industry-analysis/segmentation/growth-overview/GrowthOverview";
import { SizeAndGrowthOverview } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/SizeAndGrowthOverview";

export const IndustrySegmentation = () => {
    const { params } = useCurrentStateAndParams();
    const isCompareMode = Boolean(params.comparedDuration);

    return (
        <PageContainer>
            <PreDefinedIndustriesBenchmarkBanner />
            {isCompareMode ? (
                <>
                    <SizeAndGrowthOverview />
                    <PreDefinedIndustriesBenchmarkTable />
                </>
            ) : (
                <>
                    <GrowthOverview />
                    <SizeAndGrowthOverview />
                </>
            )}
        </PageContainer>
    );
};
